import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getMessaging, getToken, onMessage } from "firebase/messaging";

const firebaseConfig = {
  apiKey: "AIzaSyDr0DMz0DpzSMPaHfXwZEbI4Mm5YHdkfYo",
  authDomain: "aom-login.firebaseapp.com",
  projectId: "aom-login",
  storageBucket: "aom-login.appspot.com",
  messagingSenderId: "915787193152",
  appId: "1:915787193152:web:9f77968fb95cb0c98378a5",
  measurementId: "G-GMCMYLKHV7"
};

const app = initializeApp(firebaseConfig);


const messaging = getMessaging(app);
onMessage(messaging, (payload) => {
  console.log('Message received. ', payload);
  // ...
});

getToken(messaging, { vapidKey: 'BGFAnimvVPcpr7RVfE6JYNRCkqoYWOQM6L6LUMSnloYehcTzdwv4Q1QM2Ffvc-4iPyK5H3uPrFkHiiDo4FGdCSQ' }).then((currentToken) => {
  if (currentToken) {
    console.log('Token de registro obtido com sucesso:', currentToken);
    // ...
  } else {
    console.log('No registration token available. Request permission to generate one.');
    // ...
  }
}).catch((err) => {
  console.log('An error occurred while retrieving token. ', err);
  // ...
});



const auth = getAuth(app);

export { auth, messaging };
